module.exports = global["App"] = require("-!/var/www/clients/client44/web149/web/node_modules/ts-loader/index.js??ref--0-0!./App.ts");


//////////////////
// WEBPACK FOOTER
// ./node_modules/expose-loader?App!./src/script/app/App.ts-exposed
// module id = 45
// module chunks = 3